import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthorizationService } from '@core/authorization.service';
import { AuthenticationService } from './authentication.service';
import { Clients } from '@models/clients';
import { forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class AppPermissionGuardService implements CanActivate {
  constructor(
    private router: Router,
    private authorizationService: AuthorizationService,
    private authenticationService: AuthenticationService,
  ) {}

  canActivate() {
    const token = this.authenticationService.getAccessToken();
    if (!token) {
      return false;
    }

    return forkJoin({
      bridget: this.authorizationService.getPermissions(Clients.BRIDGET),
      jimbo: this.authorizationService.getPermissions(Clients.JIMBO),
    }).pipe(
      map(({ bridget, jimbo }) => {
        const hasAnyPermission = bridget.length > 0 || jimbo.length > 0;
        if (hasAnyPermission) {
          return true;
        }
        return this.router.createUrlTree(['/no-permissions']);
      }),
    );
  }
}
